// @flow

import duplicateOrderItem from '../../../Services/duplicateOrderItem';
import type { DuplicateOrderItemParams } from '../../../types';

export default (params: DuplicateOrderItemParams) => async (dispatch: Function) => dispatch(duplicateOrderItem(params))